import { Tab, Tabs } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import { useState } from 'react';
import './styles.scss';

interface tabType {
    title: string;
    eventKey: string;
    content: React.ReactNode;
}
interface ConfigurationTabsProps {
    configTabs: tabType[];
    /** When provided with `onActiveKeyChange`, tab selection is controlled by the parent (survives parent re-renders). */
    activeKey?: string;
    onActiveKeyChange?: (eventKey: string) => void;
    /** Runs before the active tab changes; await async work (e.g. flush pending saves). */
    onBeforeTabChange?: (previousKey: string, nextKey: string) => void | Promise<void>;
}

const ConfigurationTabs = ({ configTabs, activeKey, onActiveKeyChange, onBeforeTabChange }: ConfigurationTabsProps) => {
    const [internalActiveTab, setInternalActiveTab] = useState<string>(configTabs[0].eventKey);
    const isControlled = activeKey !== undefined;
    const activeTab = isControlled ? activeKey : internalActiveTab;

    const onSelect = async (eventKey: string | null) => {
        const nextKey = eventKey ?? '';
        if (!nextKey || nextKey === activeTab) {
            return;
        }
        await onBeforeTabChange?.(activeTab, nextKey);
        if (isControlled) {
            onActiveKeyChange?.(nextKey);
        } else {
            setInternalActiveTab(nextKey);
        }
    };

    return (
        <div className="d-flex flex-column p-2 gap-3 config-tabs">
            <div className="w-100">
                <Tabs activeKey={activeTab} onSelect={onSelect} className="config-tabs__custom-tabs">
                    {configTabs.map((tab: tabType) => (
                        <Tab
                            key={tab.eventKey}
                            eventKey={tab.eventKey}
                            unmountOnExit={false}
                            title={
                                <Typography
                                    variant={activeTab === tab.eventKey ? 'body2' : 'body5'}
                                    color={activeTab === tab.eventKey ? 'text-high-emphasis' : 'text-medium-emphasis'}
                                    style={{ textTransform: 'uppercase' }}
                                >
                                    {tab.title}
                                </Typography>
                            }
                        >
                            <div className="content-container pt-4">{tab.content}</div>
                        </Tab>
                    ))}
                </Tabs>
            </div>
        </div>
    );
};

export default ConfigurationTabs;
